import { useQuery } from 'react-query';
import { request } from '../../../config/helpers/axios-instance';

// `{ orderId, transitions, edits }` -- status changes plus ops edits for one order.
const useOrderHistory = (orderId) =>
    useQuery(
        ['order-history', orderId],
        () => request({ url: `/ops/orders/${orderId}/history`, method: 'GET' }),
        { enabled: !!orderId, refetchOnWindowFocus: false }
    );

export default useOrderHistory;
